var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('img',{attrs:{"src":this.getImage(),"width":"100","height":"100"}}),_vm._v("\n  "+_vm._s(_vm.params.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }